module.exports = __webpack_public_path__ + "img/823-db46a9.png";